import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=168aec89&"
import script from "./ProjectsView.vue?vue&type=script&lang=ts&"
export * from "./ProjectsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=168aec89&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports